import { ModalService } from '../../components/modal/modal.service';
import { RestService } from '../../utils/services/rest.service';
import { Item } from '../../../core/models/item.model';
import { Component, Input, EventEmitter, Output } from '@angular/core';
import { ConfirmedModalComponent } from 'src/app/features/modals/confirmed-modal/confirmed-modal.component';
import { AcknowledgmentModalComponent } from 'src/app/features/modals/acknowledgment-modal/acknowledgment-modal.component';
import { AlertService } from '../../utils/services/alert.service';
import { Subscription } from 'rxjs';
import { GiftBagService } from '../gift-bag/gift-bag.service';
import { GiftBagExistisModalComponent } from 'src/app/features/modals/gift-bag-existis-modal/gift-bag-existis-modal.component';
import { AuthService } from '../../utils/services/auth.service';
import { IBag, IGift, IUser } from 'src/app/core/models/user.model';

@Component({
  selector: 'app-card-item',
  templateUrl: './card-item.component.html',
  styleUrls: ['./card-item.component.scss']
})
export class CardItemComponent {

  private subscription$: Subscription;

  @Output() bagEvent = new EventEmitter();

  @Input() description: string;
  @Input() image: string;
  @Input() confirmedQuantity: number;
  @Input() limitQuantity: number;
  @Input() status: boolean;
  @Input() item: IGift;
  @Input() key: string;

  constructor(
    private restService: RestService,
    private modalService: ModalService,
    private alertService: AlertService,
    private giftBagService: GiftBagService,
    private authService: AuthService
    ) { }

  public onClick(): void {
    if (!this.isItemJaFoiSelecionado(this.item)) {
      this.showConfirmModal();
      this.subscription$ = this.modalService.modalResponse$.subscribe((isAdicionar) => {
        if (isAdicionar) {
          this.addBag();
        }
        this.subscription$.unsubscribe();
      });
    } else {
      this.modalService.showModal(GiftBagExistisModalComponent)
    }
  }

  private addBag(): void {
    const user: IUser = this.authService.getUser();
    user.bag = user.bag ? this.formatForArray(user.bag) : [];
    let arr = [];
    const newGiftSelected: IBag = {
      gift: this.item,
      key: this.key,
      selectedQuantity: 1
    };
    arr.push(newGiftSelected);
    user.bag ? user.bag.push(newGiftSelected) : user.bag = arr;
    this.restService.updateUser(user.key, user);
    this.restService.updateItem(this.item, this.key);
    this.bagEvent.emit(this.item);
    setTimeout(() => {
      this.showAcknowledgmentModal();
    }, 200);
  }

  private formatForArray = (data: IBag[]) => Object.values(data).map((item) => item);

  private isItemJaFoiSelecionado(item: Item) {
    const result = this.giftBagService.verifyItemExistis(item.description);
    return result;
  }

  public showConfirmModal(): void {
    const data = {
      image: this.item.image,
      description: this.item.description
    };
    this.modalService.showModal(ConfirmedModalComponent, data);
  }

  public showAcknowledgmentModal(): void {
    this.modalService.showModal(AcknowledgmentModalComponent);
  }
}
